<template>
  <div id="home">
    <div id="home-1">
      <div style="font-size:30px">铿锵侠</div>
      <div style="font-size:16px;margin-bottom:20px">一个目前在帝都的GISer。</div>
      <div style="font-size:16px;width:300px;text-align:center;margin:0 auto;">程序员里地图画的很好，画地图里文章写得很棒，写文章里编程编的不错。就是这么一个人。</div>
      <div style="font-size:16px;margin-top:30px">
        <div id="home-pic-1"></div>
        <div>
          <strong>知乎主页</strong>
        </div>
        <Tooltip content="知乎主页" placement="right">
          <a style="font-size:16px" href="https://www.zhihu.com/people/kengqiangxia" target="_blank">铿锵侠</a>
        </Tooltip>
        <div>知乎专栏</div>
      </div>
      <Tooltip content="科普为主，适合所有人阅读" placement="right">
        <a style="font-size:16px" href="https://zhuanlan.zhihu.com/mapworld" target="_blank">《地图看世界》</a>
      </Tooltip>
      <br>
      <Tooltip content="技术为主，适合GIS初学者阅读" placement="right">
        <a style="font-size:16px" href="https://zhuanlan.zhihu.com/GISDevelop" target="_blank">《GIS开发从入门到放弃》</a>
      </Tooltip>
      <div style="font-size:16px;margin-top:30px">
        <div id="home-pic-3"></div>
        <span>微信公众号</span>
      </div>
      <Tooltip content="欢迎扫描二维码，添加关注" placement="right">
        <span style="font-size:16px;color:#2d8cf0;cursor:pointer;width:100px;text-align:center" @click="toMapView">mapsworld</span>
      </Tooltip>
      <div style="font-size:16px;margin-top:30px">
        <div>
          <Icon type="map"></Icon>
        </div>
        <span>地图应用</span>
      </div>
      <span style="font-size:16px;color:#2d8cf0;cursor:pointer;width:100px;text-align:center" @click="toMapView">地图列表</span>
      <div style="font-size:16px;margin-top:30px">
        <div id="home-pic-2"></div>
        <span>淘宝店</span>
      </div>
      <a style="font-size:16px" href="https://shop113148564.taobao.com" target="_blank">地图看世界周边</a>
    </div>
    <canvas id="home-cartoon"></canvas>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'home',
    data() {
      return {
        columns1: 0,
        columns2: 0,
      }
    },
    computed: {},
    mounted() {
      this.init();
      this.initHttpQuest();
    },
    watch: {},
    methods: {
      // 初始化
      init() {
        this.$Notice.destroy();
        this.$Notice.open({
          title: 'ฅ^•ﻌ•^ฅ',
          desc: '铿锵侠的主页&试验田',
          duration: 0
        });
        document.addEventListener('touchmove', function (e) {
          e.preventDefault()
        })
        var c = document.getElementsByTagName('canvas')[0],
          x = c.getContext('2d'),
          pr = window.devicePixelRatio || 1,
          w = window.innerWidth,
          h = window.innerHeight,
          f = 90,
          q,
          m = Math,
          r = 0,
          u = m.PI * 2,
          v = m.cos,
          z = m.random
        c.width = w * pr
        c.height = h * pr
        x.scale(pr, pr)
        x.globalAlpha = 0.6

        function i() {
          x.clearRect(0, 0, w, h)
          q = [{
            x: 0,
            y: h * .7 + f
          }, {
            x: 0,
            y: h * .7 - f
          }]
          while (q[1].x < w + f) d(q[0], q[1])
        }

        function d(i, j) {
          x.beginPath()
          x.moveTo(i.x, i.y)
          x.lineTo(j.x, j.y)
          var k = j.x + (z() * 2 - 0.25) * f,
            n = y(j.y)
          x.lineTo(k, n)
          x.closePath()
          r -= u / -50
          x.fillStyle = '#' + (v(r) * 127 + 128 << 16 | v(r + u / 3) * 127 + 128 << 8 | v(r + u / 3 * 2) * 127 + 128).toString(
            16)
          x.fill()
          q[0] = q[1]
          q[1] = {
            x: k,
            y: n
          }
        }

        function y(p) {
          var t = p + (z() * 2 - 1.1) * f
          return (t > h || t < 0) ? y(p) : t
        }
        document.onclick = i
        document.ontouchstart = i
        i()
      },
      // https://zhuanlan.zhihu.com/api/columns/mapworld
      initHttpQuest() {
        // debugger
        // var htmlobj = $.ajax({
        //   url: "https://zhuanlan.zhihu.com/api/columns/mapworld",
        //   async: false,
        //   dataType: 'jsonp',
        //   success: function (data) {
        //     debugger
        //     var data = data;
        //   }
        // });
      },
      toMapView() {
        this.$router.push({
          name: "mapHome",
        });
      },
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #home {
    overflow-y: hidden;
  }

  #home-1 {
    margin: 0 auto;
    margin-top: 50px;
    text-align: center;
    /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.647058823529412);*/
    font-family: '微軟正黑體 Bold', '微軟正黑體';
    font-weight: 700;
    font-style: normal;
    color: black;
    z-index: 10;
  }

  #home-cartoon {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
  }

  #home-pic-1 {
    background-image: url("../../static/zhi.jpg");
    background-size: contain;
    z-index: 10;
    width: 25px;
    height: 25px;
    margin: 0 auto;
  }

  #home-pic-2 {
    background-image: url("../../static/tao.jpg");
    background-size: contain;
    z-index: 10;
    width: 25px;
    height: 25px;
    margin: 0 auto;
  }

  #home-pic-3 {
    background-image: url("../../static/weixin.jpg");
    background-size: contain;
    z-index: 10;
    width: 25px;
    height: 25px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// Home.vue?198a5fb6